import React, { useCallback } from "react";
import { Body4 } from "../../../typography";
import { Wrapper, IconContainer, SelectableCircle, } from "./SelectableField.style";
import { SelectedRadio } from "../../../icons";
import { useTheme } from "@emotion/react";
/** @deprecated Use Card instead */
export const SelectableField = (props) => {
    var _a;
    const theme = useTheme();
    const onClick = useCallback(() => {
        var _a;
        if (props.disabled) {
            return;
        }
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, props.value);
    }, [props.onChange, props.disabled]);
    return (React.createElement(Wrapper, { "data-testid": (_a = props["data-testid"]) !== null && _a !== void 0 ? _a : "selectable-field", selected: props.selected, className: `${props.className} ${props.selected ? "selected" : ""}`, isDisabled: props.disabled, onClick: onClick, grow: props.grow, style: props.style },
        React.createElement(IconContainer, null, props.icon ? (React.createElement("img", { src: props.icon, alt: props.value.toString() })) : props.selected ? (React.createElement(SelectedRadio, { size: 24, color: props.disabled ? theme.colors.light[40] : theme.colors.primary[50] })) : (React.createElement(SelectableCircle, { className: "selectable-circle" }))),
        props.name != undefined ? (React.createElement(Body4, { className: "selectable-field-name", fontWeight: props.fontWeight, inline: true }, props.name)) : (props.children)));
};
//# sourceMappingURL=SelectableField.js.map